import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EmbedLoginService, JwtService } from '@core/services';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-client-selector',
  templateUrl: './client-selector.component.html',
  styleUrls: ['./client-selector.component.scss']
})
export class ClientSelectorComponent implements OnInit {
  public clientsList: Array<any> = [];
  public error: any = null;
  private token: string = null;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private embedLoginService: EmbedLoginService,
    private jwtService: JwtService
  ) {}

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParams.token;
    const data = this.jwtService.getTokenData(this.token);
    this.clientsList = data?.clients;
  }

  handleSelectUser(clientId: string): void {
    this.authService
      .createServiceLogin({
        token: this.token,
        clientId: clientId
      })
      .subscribe({
        next: (response) => {
          this.embedLoginService.onLoginSuccess(response);
        },
        error: (error) => {
          console.error(error);
          this.error = error;
        }
      });
  }
}
